import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './cons-take-in-charge-document-type.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsTakeInChargeDocumentTypeDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const consTakeInChargeDocumentTypeEntity = useAppSelector(state => state.consTakeInChargeDocumentType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consTakeInChargeDocumentTypeDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.detail.title">ConsTakeInChargeDocumentType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{consTakeInChargeDocumentTypeEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.code">Code</Translate>
            </span>
          </dt>
          <dd>{consTakeInChargeDocumentTypeEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.name">Name</Translate>
            </span>
          </dt>
          <dd>{consTakeInChargeDocumentTypeEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{consTakeInChargeDocumentTypeEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{consTakeInChargeDocumentTypeEntity.nameEn}</dd>
          <dt>
            <span id="folderName">
              <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.folderName">Folder Name</Translate>
            </span>
          </dt>
          <dd>{consTakeInChargeDocumentTypeEntity.folderName}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.consTakeInChargeDocumentType.status">Status</Translate>
            </span>
          </dt>
          <dd>{consTakeInChargeDocumentTypeEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/cons-take-in-charge-document-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cons-take-in-charge-document-type/${consTakeInChargeDocumentTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsTakeInChargeDocumentTypeDetail;
